import React from 'react'

import { Box, Typography } from "@mui/material"
import { USER_ROLE } from "Pages/Admin/Users/@constants"


export default function roleColumn() {

	return {
		name: 'role',
		label: 'Role',
		options: {
			customBodyRowRenderLite: value => <Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}>
				<Typography sx={{
					borderBottom: "2px solid",
					borderColor: value === USER_ROLE.ADMIN ? "error.main" : "info.main",
					fontWeight: "bold"
				}}>
					{value}
				</Typography>
			</Box>
		}
	}
}